import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceScoreCard = ({ title, value, subtitle, status, trend, icon }) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'compliant':
        return {
          bg: 'bg-emerald-50 dark:bg-emerald-900/20',
          text: 'text-emerald-700 dark:text-emerald-400',
          border: 'border-emerald-200 dark:border-emerald-800',
          iconBg: 'bg-emerald-100 dark:bg-emerald-900/40'
        };
      case 'warning':
        return {
          bg: 'bg-amber-50 dark:bg-amber-900/20',
          text: 'text-amber-700 dark:text-amber-400',
          border: 'border-amber-200 dark:border-amber-800',
          iconBg: 'bg-amber-100 dark:bg-amber-900/40'
        };
      case 'critical':
        return {
          bg: 'bg-red-50 dark:bg-red-900/20',
          text: 'text-red-700 dark:text-red-400',
          border: 'border-red-200 dark:border-red-800',
          iconBg: 'bg-red-100 dark:bg-red-900/40'
        };
      default:
        return {
          bg: 'bg-gray-50 dark:bg-slate-800',
          text: 'text-gray-700 dark:text-gray-300',
          border: 'border-gray-200 dark:border-slate-700',
          iconBg: 'bg-gray-100 dark:bg-slate-700'
        };
    }
  };

  const getTrendIcon = () => {
    if (trend > 0) return 'TrendingUp';
    if (trend < 0) return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend > 0) return 'text-emerald-600 dark:text-emerald-400';
    if (trend < 0) return 'text-red-600 dark:text-red-400';
    return 'text-gray-500 dark:text-gray-400';
  };

  const styles = getStatusStyles();

  return (
    <div className={`bg-white dark:bg-slate-800 border ${styles?.border} rounded-lg p-5 transition-all hover:shadow-md hover:border-emerald-300 dark:hover:border-emerald-600 w-full`}>
      <div className="flex items-start justify-between mb-3">
        <div className={`${styles?.iconBg} p-2 rounded-lg flex-shrink-0`}>
          <Icon name={icon} size={20} className={styles?.text} />
        </div>
        {trend !== undefined && (
          <div className="flex items-center gap-1 flex-shrink-0">
            <Icon name={getTrendIcon()} size={16} className={getTrendColor()} />
            <span className={`text-xs font-medium ${getTrendColor()}`}>
              {Math.abs(trend)}%
            </span>
          </div>
        )}
      </div>
      <h3 className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 uppercase tracking-wide">{title}</h3>
      <div className="flex items-baseline gap-2 mb-1">
        <span className={`text-2xl font-bold ${styles?.text}`}>
          {value}
        </span>
      </div>
      {subtitle && (
        <p className="text-xs text-gray-500 dark:text-gray-400">{subtitle}</p>
      )}
    </div>
  );
};

export default ComplianceScoreCard;